import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=d97b3bd6&scoped=true&lang=pug"
import script from "./StudentList.vue?vue&type=script&lang=ts"
export * from "./StudentList.vue?vue&type=script&lang=ts"
import style0 from "./StudentList.vue?vue&type=style&index=0&id=d97b3bd6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97b3bd6",
  null
  
)

export default component.exports